module.exports = __webpack_public_path__ + "static/media/la.fc6ba6be.svg";